import { useMemo } from "react";

import { useSelectorTrigger } from "app/components/filters-bar/useSelectorTrigger";
import { TrafficTopCountries } from "app/components/TrafficTopCountries/TrafficTopCountries";
import { useTopCountriesData } from "app/pages/website-performance/components/TopCountries/useTopCountriesData";
import DurationService from "app/services/DurationService";

const TitleKey = "ia.overview.geography";
const ToolTipKey = "wwo.geography.tooltip";

const WWOTrafficTopCountries = ({ params, getCtaLink, unlockHook = null, hideFooter = false }) => {
    const { selectorHandlers } = useSelectorTrigger("traffic-top-countries");
    const { from, to, isWindow } = useMemo(() => DurationService.getDurationData(params.duration).forAPI, []);

    const siteNames = useMemo(() => params.key.split(","), []);
    const isCompare = siteNames.length > 1;

    const ctaHref = getCtaLink();

    const { data, isLoading } = useTopCountriesData({
        keys: params.key,
        webSource: params.webSource,
        includeSubDomains: params.isWWW === "*",
        from,
        to,
        isWindow,
    });

    return (
        <TrafficTopCountries
            countriesTrafficShare={data ?? []}
            ctaHref={ctaHref}
            isLoading={isLoading}
            isCompare={isCompare}
            unlockHook={unlockHook}
            params={params}
            textKeys={{ titleKey: TitleKey, titleTooltipKey: ToolTipKey }}
            hideFooter={hideFooter}
            onDateClick={selectorHandlers.onDateClick}
            onDateHover={selectorHandlers.onDateHover}
            onWebSourceHover={selectorHandlers.onWebSourceHover}
        />
    );
};

export default WWOTrafficTopCountries;
